module.exports = __webpack_public_path__ + "img/m1.de3577f4.jpg";